// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.home_container__gc\\+Y2 {
    margin-left: 100px;
    display: flex;
    justify-content: center;
    text-align: left;
}

.home_title__652VX {
    font-weight: 500;
    color: #444;
    font-size: 32px;
}

.home_description__y42Eb {
    color: #bbb;
    font-weight: 500;
    flex-basis: 30%;
}

.home_optionsContainer__zW-5l {
    margin: 1rem 0;
    border-left: #eee 4px solid;
    padding-left: 2rem;
    flex-basis: 70%;
    display: flex;
    flex-direction: column;

}

.home_section__pNF1d {
    display: flex;
}

.home_inputTitle__PONrQ {
    color: #777;
    font-weight: 500;
}

.home_distanceContainer__i7vH5 {
    position: absolute;
    top: 10px;
    right: 30px;
    height: 70px;
    background-color: #FFF;
    border-radius: 8px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 2rem;
}

.home_distanceBox__3HJ37 {
    color: #000;
    font-weight: 600;
    margin-left: 0.4rem;
    border: #ccc 2px solid;
    padding: 0.2rem 0.4rem;
    border-radius: 6px;
}`, "",{"version":3,"sources":["webpack://./src/screens/home/home.module.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,2BAA2B;IAC3B,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,sBAAsB;;AAE1B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,mBAAmB;IACnB,sBAAsB;IACtB,sBAAsB;IACtB,kBAAkB;AACtB","sourcesContent":[".container {\n    margin-left: 100px;\n    display: flex;\n    justify-content: center;\n    text-align: left;\n}\n\n.title {\n    font-weight: 500;\n    color: #444;\n    font-size: 32px;\n}\n\n.description {\n    color: #bbb;\n    font-weight: 500;\n    flex-basis: 30%;\n}\n\n.optionsContainer {\n    margin: 1rem 0;\n    border-left: #eee 4px solid;\n    padding-left: 2rem;\n    flex-basis: 70%;\n    display: flex;\n    flex-direction: column;\n\n}\n\n.section {\n    display: flex;\n}\n\n.inputTitle {\n    color: #777;\n    font-weight: 500;\n}\n\n.distanceContainer {\n    position: absolute;\n    top: 10px;\n    right: 30px;\n    height: 70px;\n    background-color: #FFF;\n    border-radius: 8px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    font-size: 2rem;\n}\n\n.distanceBox {\n    color: #000;\n    font-weight: 600;\n    margin-left: 0.4rem;\n    border: #ccc 2px solid;\n    padding: 0.2rem 0.4rem;\n    border-radius: 6px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `home_container__gc+Y2`,
	"title": `home_title__652VX`,
	"description": `home_description__y42Eb`,
	"optionsContainer": `home_optionsContainer__zW-5l`,
	"section": `home_section__pNF1d`,
	"inputTitle": `home_inputTitle__PONrQ`,
	"distanceContainer": `home_distanceContainer__i7vH5`,
	"distanceBox": `home_distanceBox__3HJ37`
};
export default ___CSS_LOADER_EXPORT___;
